var map = {
	"./goal.png": 4835,
	"./missedPenalty.png": 4746,
	"./owngoal.png": 7020,
	"./penalty.png": 6203,
	"./redcard.png": 1807,
	"./secondyellow.png": 4991,
	"./yellowcard.png": 9595
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5954;